import { ChevronDownIcon, ChevronRightIcon } from '@/imports/ui/chakra/feather';
import {
  Box,
  Collapse,
  HStack,
  IconButton,
  Stack,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';

interface CollapsibleNavGroupMenuProps {
  isActive?: boolean;
  defaultOpen?: boolean;
  rightPadding?: number | string;
  children: React.ReactNode;
  header: React.ReactNode;
}

export const CollapsibleNavGroupMenu: React.FC<CollapsibleNavGroupMenuProps> = ({
  header,
  isActive = false,
  defaultOpen = false,
  children,
}) => {
  const { isOpen, onOpen, onToggle } = useDisclosure({
    defaultIsOpen: defaultOpen || isActive,
  });

  React.useEffect(() => {
    if (isActive) {
      onOpen();
    }
  }, [isActive, onOpen]);

  const handleToggle = () => {
    onToggle();
  };

  return (
    <Stack spacing="1" w="full">
      {/* Header */}
      <HStack position="relative" align="center" w="full">
        <Box w="full">{header}</Box>

        {/* Arrow */}
        <IconButton
          aria-label="Toggle section"
          size="sm"
          variant=""
          position="absolute"
          right="2"
          onClick={handleToggle}
          icon={
            isOpen ? (
              <ChevronDownIcon boxSize="5" />
            ) : (
              <ChevronRightIcon boxSize="5" />
            )
          }
        />
      </HStack>

      {/* Content */}
      <Collapse in={isOpen} animateOpacity>
        <Stack spacing="1">{children}</Stack>
      </Collapse>
    </Stack>
  );
};
